import React from "react"
import { ClassProps } from "../../utility/common/props"
import ContextMenu from "../ContextMenu/ContextMenu"
import styles from "./SettingsContextMenu.module.scss"
import cn from "classnames"
import { Placement } from "react-bootstrap/esm/Overlay"

export interface SettingsContextMenuProps extends ClassProps {
    children: React.ReactNode
    items: React.ReactNode
    onHide?: () => void
    placement?: Placement
    closeWhenClickInside?: boolean
    keepOnlyOneOpened?: boolean
}

const SettingsContextMenu: React.FC<SettingsContextMenuProps> = props => {
    const { children, items, onHide, className, placement = "bottom" } = props

    return (
        <ContextMenu
            {...props}
            items={items}
            placement={placement}
            className={styles.settingsContextMenu}
            containerClassName={cn(styles.settingsContextMenu__container, className)}
            onHide={onHide}
            popperConfig={{
                modifiers: [
                    {
                        name: "flip",
                        enabled: true
                    }
                ]
            }}
        >
            {children}
        </ContextMenu>
    )
}

export default SettingsContextMenu
